<template>
  <li class="nav-item">
    <component
      :is="to != null ? 'router-link' : 'a'"
      v-bind="linkProps"
      :class="linkClasses"
      v-on="$listeners"
    >
      <slot />
    </component>
  </li>
</template>

<script>
export default {
  name: "BaseNavItem",
  inheritAttrs: false,
  props: {
    /** For `<router-link>` navigation; if absent, falls back to `href` */
    to: {
      type: [String, Object],
      default: null,
    },
    /** Standard link href */
    href: {
      type: String,
      default: null,
    },
    /** Marks the item active (`.active` class) */
    active: {
      type: Boolean,
      default: false,
    },
    /** Marks the item disabled (`.disabled` class + aria-disabled) */
    disabled: {
      type: Boolean,
      default: false,
    },
    /** When using `to`, whether the link must exactly match */
    exact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // props/attrs to bind to the <a> or <router-link>
    linkProps() {
      const p = { ...this.$attrs };
      if (this.to != null) {
        p.to = this.to;
        p.exact = this.exact;
        // Vue Router 4 uses `aria-current="page"` automatically for active links
      } else {
        p.href = this.href || "#";
      }
      if (this.disabled) {
        p["aria-disabled"] = "true";
        p.tabindex = "-1";
      }
      return p;
    },
    // bootstrap classes for the link element
    linkClasses() {
      return {
        "nav-link": true,
        active: this.active,
        disabled: this.disabled,
      };
    },
  },
};
</script>
